export default "__VITE_ASSET__uRIvFrBX__"